import { stringify } from 'src/core/hooks/use-translation'
import * as Yup from 'yup'

import {
  Contract,
  CostCenter,
  Request,
  RequestStandardSharing
} from 'src/types'

type ValidateProps = {
  request: Request
  t: any
  values: RequestStandardSharing
}
function getInitialValues(
  requestSharing?: CostCenter,
  requestContract?: Contract
): RequestStandardSharing {
  const defaultInitialValue: RequestStandardSharing = {
    active: true,
    contract_id: null,
    contract: null,
    cost_center_id: null,
    cost_center: null,
    percentage: 100,
    request_id: null,
    request_standard_sharing_id: null,
    request_standard_sharing_number: null,
    request_ticket_sharing_type: 'UNIFIED'
  }
  if (requestSharing) {
    defaultInitialValue.cost_center_id = requestSharing.cost_center_id
    defaultInitialValue.cost_center = requestSharing
  }
  if (requestContract) {
    defaultInitialValue.contract_id = requestContract.contract_id
    defaultInitialValue.contract = requestContract
  }

  return defaultInitialValue
}

function getValidationSchema() {
  return Yup.object().shape({
    cost_center_id: Yup.number()
      .when('active', {
        is: true,
        then: Yup.number()
          .required('common.required')
          .typeError('common.required')
      })
      .typeError('common.required'),
    contract_id: Yup.number()
      .when('active', {
        is: true,
        then: Yup.number()
          .required('common.required')
          .typeError('common.required')
      })
      .typeError('common.required'),
    percentage: Yup.number().when('active', {
      is: true,
      then: Yup.number()
        .typeError('common.required')
        .min(
          1,
          stringify('web.assignment.sharing.form.percentage.min-percentage', {
            num: 1
          })
        )
        .required('common.required')
    })
  })
}

function validate({ request, t, values }: ValidateProps): object {
  const errors: any = {}

  const totalPercentage =
    request.request_standard_assignments.request_standard_sharings
      .filter(item => {
        let is = item.active

        if (values.tmp_id) {
          is = is && item.tmp_id !== values.tmp_id
        } else if (item.request_standard_sharing_id) {
          is =
            is &&
            item.request_standard_sharing_id !==
              values.request_standard_sharing_id
        }

        return is
      })
      .reduce(
        (accumulator: number, { percentage }: { percentage: number }) =>
          accumulator + percentage,
        0
      )

  if (totalPercentage + values.percentage > 100) {
    errors.percentage = stringify(
      'web.assignment.sharing.form.percentage.max-percentage',
      { num: 100 }
    )
  }

  return errors
}

export { getInitialValues, getValidationSchema, validate }
